
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_GB_46json_79fcecd6",
      load: () => import("#nuxt-i18n/79fcecd6" /* webpackChunkName: "locale_en_GB_46json_79fcecd6" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_FR_46json_001961a4",
      load: () => import("#nuxt-i18n/001961a4" /* webpackChunkName: "locale_fr_FR_46json_001961a4" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "locale-detector.ts",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      files: [
        {
          path: "/src/i18n/locales/en_GB.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr",
      files: [
        {
          path: "/src/i18n/locales/fr_FR.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "property/sell": {
      en: "/sell",
      fr: "/vendre"
    },
    "property/[propertySlug]/r[propertyListingRef]": {
      en: "/ad/[propertySlug]/r[propertyListingRef]",
      fr: "/annonce/[propertySlug]/r[propertyListingRef]"
    },
    "property/r[propertyListingRef]": {
      en: "/ad/r[propertyListingRef]",
      fr: "/annonce/r[propertyListingRef]"
    },
    "serp/[...serpSlug]": {
      en: "/ads/[...serpSlug]",
      fr: "/annonces/[...serpSlug]"
    },
    serp: {
      en: "/ads",
      fr: "/annonces"
    },
    valuation: {
      en: "/estimate",
      fr: "/estimer-votre-bien"
    },
    "valuation/house": {
      en: "/estimate/housevilla",
      fr: "/estimer-votre-bien/maison"
    },
    "valuation/apartment": {
      en: "/estimate/apartment",
      fr: "/estimer-votre-bien/appartement"
    },
    "valuation/online-valuation": {
      en: "/estimate/online-valuation",
      fr: "/estimer-votre-bien/estimateur"
    },
    "find-real-estate-agent": {
      en: "/find-real-estate-agent",
      fr: "/trouver-un-conseiller"
    },
    "find-real-estate-agent/[agentSector]": {
      en: "/find-real-estate-agent/[agentSector]",
      fr: "/trouver-un-conseiller/[agentSector]"
    },
    "real-estate-agent/[userName]": {
      en: "/real-estate-agent/[userName]",
      fr: "/conseiller-immobilier/[userName]"
    },
    "real-estate-agent/[userName]?": {
      en: "/real-estate-agent/[userName]",
      fr: "/conseiller-immobilier/[userName]"
    },
    "real-estate-agent/[userName]/valuation": {
      en: "/real-estate-agent/[userName]/estimate",
      fr: "/conseiller-immobilier/[userName]/estimation"
    },
    about: {
      en: "/about-iad",
      fr: "/a-propos"
    },
    accessibility: {
      en: "/accessibility",
      fr: "/accessibilite"
    },
    reviews: {
      en: "/reviews",
      fr: "/avis"
    },
    "contact-us": {
      en: "/contact-us",
      fr: "/contactez-nous"
    },
    mediation: {
      en: "/mediation",
      fr: "/mediation"
    },
    "privacy-policy": {
      en: "/privacy-policy",
      fr: "/politique-de-confidentialite"
    },
    "legal-mentions": {
      en: "/legal-mentions",
      fr: "/mentions-legales"
    },
    "cookie-policies": {
      en: "/cookie-management-policy",
      fr: "/politique-de-gestion-des-cookies"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    files: [
      {
        path: "/src/i18n/locales/en_GB.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr",
    files: [
      {
        path: "/src/i18n/locales/fr_FR.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/